import { useFormik } from "formik";
import { useEffect, useState } from "react";
import * as Yup from 'yup';
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { folderService } from "services/folder.service";
import { AiOutlineEyeInvisible, AiFillEye } from 'react-icons/ai';
import eyeImg from 'assets/images/eye.png';

const EditFolder = (props) => {
    const { show, handleClose, folder, data, setData } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState();
    const [password, setPassword] = useState('');
    const [response, setResponse] = useState(false)

    const formik = useFormik({
        initialValues: {
            title: folder?.title,
            link: folder?.link,
            password: folder?.password,
            folderId: `${folder?._id}`
        },
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            title: Yup.string().required("Please enter Folder name").max(20, 'First Name must be at most 15 characters'),
            link: Yup.string().required("Please enter Google Drive Link"),
            password: Yup.string().required("Please enter password").min(4, "Password should be at least 4 characters").max(10, "Password should be at most 10 characters long"),
        }),
        onSubmit: async (values) => {
            try {
                const response = await folderService.editfolder(values);
                if (response?.data?.success) {
                    toast.success(response?.data?.message, { autoClose: 2000 });
                    setResponse(response?.data?.message)

                    const editedFolderIndex = data.folders.findIndex((folder) => folder._id === values.folderId);
                    const updatedFolders = [...data.folders];
                    updatedFolders[editedFolderIndex] = response?.data?.data;
                    setData({
                        totalFolders: updatedFolders.length,
                        folders: updatedFolders,
                    });
                    handleClose();
                } else {
                    // toast.warning(response?.data?.message, { autoClose: 4000 });
                    setError(response?.data?.message);
                }
                
            } catch (err) {
                console.error(err?.response?.data?.message);
                setError(err?.response?.data?.message);
            }
        },
    });

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const generatePassword = () => {
        // Define the characters that can be used in the password
        const characters =
            'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+~`|}{[]:;?><,./-=';

        // Set the desired length of the password
        const passwordLength = 10;

        let generatedPassword = '';
        for (let i = 0; i < passwordLength; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            generatedPassword += characters[randomIndex];
        }

        setPassword(generatedPassword);
        formik.setFieldValue("password", generatedPassword)
    };
    return (
        <Modal show={show} className="modal-common" onHide={handleClose}>
            <Modal.Header closeButton>Edit Folder</Modal.Header>
            <Modal.Body>
                <form>
                    <div className="mb-30">
                        <label className="py-2">Enter Folder Name</label>
                        <br />
                        <div className="form-control-bg">
                            <input
                                type="text"
                                className="form-control rounded-3 w-100"
                                name="title"
                                id="title"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.title}
                                autoComplete="current-title"
                            />
                        </div>
                        {formik.touched.title && formik.errors.title ? (
                            <div className="text-danger">{formik.errors.title}</div>
                        ) : null}
                    </div>
                    <div className="mb-30">
                        <label className="py-2">Google Drive Link</label>
                        <br />
                        <div className="form-control-bg">
                            <input
                                type="text"
                                className="form-control rounded-3 w-100"
                                name="link"
                                id="link"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.link}
                                autoComplete="current-link"
                            />
                        </div>
                        {formik.touched.link && formik.errors.link ? (
                            <div className="text-danger">{formik.errors.link}</div>
                        ) : null}
                    </div>
                    <div className="mb-30">
                        <label className="py-2">Create Password</label>
                        <br />
                        <div className="form-control-bg">
                            <div className="d-flex password-input-container px-3 justify-content-between w-100">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className="bg-transparent border-0 w-100"
                                    name="password"
                                    id="password"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.password}
                                    autoComplete="current-password"
                                />
                                <h1
                                    className="password-toggle-icon"
                                    onClick={togglePasswordVisibility}
                                >   {showPassword ? <AiOutlineEyeInvisible size={24} /> : <img src={eyeImg} />}
                                </h1>
                            </div>
                        </div>
                        {formik.touched.password && formik.errors.password ? (
                            <div className="text-danger">{formik.errors.password}</div>
                        ) : null}
                        <span className="genrate-password text-uppercase cursor-pointer" onClick={generatePassword}>
                            Generate Password
                        </span>
                    </div>
                    {error?<div className="text-danger mb-4">{error}</div>:""}
                    <button type="button"
                        onClick={() => {
                            setIsLoading(true);
                            setTimeout(() => {

                                setIsLoading(false);
                                formik.handleSubmit();
                            }, 2000);
                        }}
                        disabled={isLoading}
                        className="btn btn-primary modal-blue-btn text-capitalize w-100 text-white"
                    >
                        {isLoading ? "Loading..." : "Submit"}
                    </button>
                </form>
            </Modal.Body>
        </Modal>

    )
}

export default EditFolder
